import React, { PropsWithChildren } from "react";
import styles from "./index.module.scss";

export type FixBadgeProps = PropsWithChildren;

const FixBadge: React.FC<FixBadgeProps> = ({ children }) => (
  <div className={styles.root}>
    <span className={styles.badge}>{children}</span>
  </div>
);

export default FixBadge;
